export default "__VITE_ASSET__e7a9a8ea__"